import angular from 'angular';

import translationsModuleName from '../../../../../lib/translation';

// Component
import component from './opportunitiesPanels.component';
import './opportunitiesPanels.css';

// Dependencies
import opportunitiesPanelModule from '../opportunitiesPanel';

const moduleName = 'staff.dashboardScreen.opportunitiesPanels';
let module = angular.module(moduleName, [
  translationsModuleName,
  opportunitiesPanelModule.name,
]);

module.component('opportunitiesPanels', component);

export default module;
